











import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    preamble: String,
    errors: Array
  },

  setup(props) {
    const hasErrors = computed(
      () =>
        props.errors != null &&
        props.errors != undefined &&
        props.errors.length > 0
    )

    return {
      hasErrors
    }
  }
})
